export default __webpack_public_path__ + "static/media/IMG-20210326-WA0037.4b004417.jpg";